import axios from 'axios'
import { apiUrl } from 'constants/defaultValues'
import { GRID_STATE_CHANGE } from 'constants/actionTypes'

import { NotificationManager } from 'react-notifications'

/**
   * Returns a simple action with just
   * the actionType and payload
   * @param {string} type - Action type
   * @param {*} payload - Data to be passed to reduceer
   * @return {Object}
   */
export const createSimpleAction = (type, payload) => ({
  type,
  payload
})

/**
   * @param {string} type - partialStateName
   * @param {*} type - partialStateValue
   * @return {Object}
   */
export const createGridAction = (partialStateName, partialStateValue) => ({
  type: GRID_STATE_CHANGE,
  partialStateName,
  partialStateValue
})

/**
   * Returns an action that doesn't require authentication
   * @param {string} resource - The API URL
   * @param {string} type - Action type
   * @param {string} requestType - GET/POST/PATCH/DELETE
   * @param {*} payload - Data to be passed to reduceer
   * @param {function} callback - Callbak function incase needed
   * @return {function}
   */
export function createUnrestrictedAction (resource, type, requestType, payload, callback) {
  return function (dispatch) {
    switch (requestType) {
      case 'POST':
        axios.post(`${apiUrl}/${resource}`, payload)
          .then(response => {
            // If request is succesful
            // Update state with all fields
            dispatch({
              type,
              payload: response.data
            })
            callback(response.data)
          })
          .catch(error => {
            // If request fails
            if (error.response) {
              const response = error.response.data
              NotificationManager.error(
                response.message,
                'An error occured',
                3000
              )
            }
          })
        break
      default:
        callback()
        dispatch({
          type,
          payload
        })
    }
  }
}

/**
   * Returns an action that requires authentication
   * @param {string} resource - The API URL
   * @param {string} type - Action type
   * @param {string} requestType - GET/POST/PATCH/DELETE
   * @param {*} payload - Data to be passed to reduceer
   * @param {function} callback - Callbak function incase needed
   * @return {function}
   */
export const createRestrictedAction = (resource, type, requestType, payload, callback) => {
  return function (dispatch) {
    const headers = { Authorization: `Bearer ${window.localStorage.getItem('token')}` }
    switch (requestType) {
      case 'GET':
        axios.get(`${apiUrl}/${resource}`, { headers })
          .then(response => {
            // If request is succesful
            // Update state with all fields
            dispatch({
              type,
              payload: response.data
            })
            if (callback) callback(response.data)
          })
          .catch(error => {
            // If request fails
            if (error.response) {
              const response = error.response.data
              NotificationManager.error(
                response.message,
                'An error occured',
                3000
              )
            } else {
              NotificationManager.error(
                'Si prega di riprovare',
                'Errore di connessione',
                5000
              )
            }
            if (callback) callback(null, error)
          })
        break
      case 'POST':
        axios.post(`${apiUrl}/${resource}`, payload, { headers })
          .then(response => {
            // If request is succesful
            // Update state with all fields
            dispatch({
              type,
              payload: response.data
            })
            NotificationManager.success(
              response.data.message,
              'Success',
              3000
            )
            if (callback) callback(response.data)
          })
          .catch(error => {
            // If request fails
            if (error.response) {
              const response = error.response.data
              NotificationManager.error(
                response.message,
                'An error occured',
                3000
              )
            } else {
              NotificationManager.error(
                'Si prega di riprovare',
                'Errore di connessione',
                5000
              )
            }
            if (callback) callback(null, error)
          })
        break
      case 'PATCH':
        axios.patch(`${apiUrl}/${resource}`, payload, { headers })
          .then(response => {
            // If request is succesful
            // Update state with all fields

            // TODO - Add dispatch for update actionTypes
            NotificationManager.success(
              response.data.message,
              'Success',
              3000
            )
            if (callback) callback(response.data)
          })
          .catch(error => {
            // If request fails
            if (error.response) {
              const response = error.response.data
              NotificationManager.error(
                response.message,
                'An error occured',
                3000
              )
            } else {
              NotificationManager.error(
                'Si prega di riprovare',
                'Errore di connessione',
                5000
              )
            }
            if (callback) callback(null, error)
          })
        break
      case 'DELETE':
        axios.delete(`${apiUrl}/${resource}`, { headers, data: {} })
          .then(response => {
            // If request is succesful
            // Update state with all fields
            dispatch({
              type,
              payload
            })
            callback(response.data)
          })
          .catch(error => {
            // If request fails
            if (error.response) {
              const response = error.response.data
              NotificationManager.error(
                response.message,
                'An error occured',
                3000
              )
            } else {
              NotificationManager.error(
                'Please try again',
                'Something went wrong',
                3000
              )
            }
          })
        break
      default:
        callback()
        dispatch({
          type,
          payload
        })
    }
  }
}

/**
   * Returns an action that requires authentication
   * @param {string} resource - The API URL
   * @param {string} type - Action type
   * @param {string} requestType - GET/POST/PATCH/DELETE
   * @param {*} formdata - Form Data to be passed to reduceer
   * @param {function} callback - Callbak function incase needed
   * @return {function}
   */
export const createUploadAction = (resource, type, requestType, formData, successCallback, errorCallback) => {
  return function (dispatch) {
    const headers = {
      'Authorization': `Bearer ${window.localStorage.getItem('token')}`,
      'Content-Type': 'multipart/form-data'
    }
    switch (requestType) {
      case 'POST':
        axios.post(`${apiUrl}/${resource}`, formData, { headers })
          .then(response => {
            // If request is succesful
            // Update state with all fields
            dispatch({
              type,
              payload: response.data
            })
            successCallback(response.data)
          })
          .catch(error => {
            // If request fails
            if (error.response) {
              const response = error.response.data
              NotificationManager.error(
                response.message,
                'An error occured',
                3000
              )
            } else {
              NotificationManager.error(
                'Please try again',
                'Something went wrong',
                3000
              )
            }
            errorCallback()
          })
        break
      case 'PUT':
        axios.put(`${apiUrl}/${resource}`, formData, { headers })
          .then(response => {
            // If request is succesful
            // Update state with all fields

            // TODO - Add dispatch for update actionTypes
            NotificationManager.success(
              response.data.message,
              'Success',
              3000
            )
            successCallback(response.data)
          })
          .catch(error => {
            // If request fails
            if (error.response) {
              const response = error.response.data
              NotificationManager.error(
                response.message,
                'An error occured',
                3000
              )
            } else {
              NotificationManager.error(
                'Please try again',
                'Something went wrong',
                3000
              )
            }
            errorCallback()
          })
        break
      default:
        break
    }
  }
}



// WEBPACK FOOTER //
// ./util/actionCreators.js